import { ParamsBuilder } from "../types";
import { RowState } from "../types";
import { helper } from "./helper";

export class TextBuilder implements ParamsBuilder {
  build(row: RowState): object {
    switch (row.operator) {
      case "contains":
        return {
          [row.fieldName]: helper(
            { contains: row.value },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "equals":
        return {
          [row.fieldName]: helper(
            { equals: row.value },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "beginsWith":
        return {
          [row.fieldName]: helper(
            { startsWith: row.value },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "endsWith":
        return {
          [row.fieldName]: helper(
            { endsWith: row.value },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "notEquals":
        return {
          [row.fieldName]: helper(
            { not: row.value },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "notBeginsWith":
        return {
          [row.fieldName]: helper(
            { not: { startsWith: row.value } },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "notEndsWith":
        return {
          [row.fieldName]: helper(
            { not: { endsWith: row.value } },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      case "notContains":
        return {
          [row.fieldName]: helper(
            { not: { contains: row.value } },
            {
              multiTableSearch: row.multiTableSearch,
              insensitive: true
            }
          )
        };
      default:
        return {};
    }
  }
}
